import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import * as Styled from './Switch.styles';

var Switch = function Switch(_ref) {
  var tableId = _ref.tableId,
      unit = _ref.unit,
      onChange = _ref.onChange;
  var checkboxRef = useRef(null);
  var id = "".concat(tableId, "__unit-toggle");

  var onSwitchChange = function onSwitchChange(e) {
    if (checkboxRef.current) {
      checkboxRef.current.focus();
    }

    if (typeof onChange === 'function') {
      onChange(e);
    }
  };

  return /*#__PURE__*/React.createElement(Styled.Switch, null, /*#__PURE__*/React.createElement(Styled.SwitchInput, {
    type: "checkbox",
    id: id,
    name: id,
    onChange: onSwitchChange,
    checked: unit === 'inch',
    ref: checkboxRef,
    role: "switch",
    "aria-label": "Toggle unit"
  }), /*#__PURE__*/React.createElement(Styled.ToggleWrapper, {
    "aria-hidden": "true"
  }, /*#__PURE__*/React.createElement(Styled.Toggle, {
    htmlFor: id
  })));
};

Switch.propTypes = {
  tableId: PropTypes.string.isRequired,
  unit: PropTypes.oneOf(['cm', 'inch']),
  onChange: PropTypes.func
};
Switch.defaultProps = {
  unit: 'cm',
  onChange: function onChange() {}
};
export default Switch;